<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner9.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li>公司介绍</li>
            </ul>
            <h3 class="tab_title">公司简介</h3>
            <p>士模微电子专注于高性能模拟信号链芯片的设计和销售，聚焦工业自动化，能源、医疗和仪器仪表等领域。公司核心技术团队由相关领域国际知名专家牵头，清华、电子科大等院校的校友组成，团队技术实力出众。同时，公司产品和营销团队在运营和市场方向具有二十年行业经验。目前公司高性能ADC/DAC产品线已经实现产品量产，实测性能指标在同类产品中处于领先地位。
            </p>
            <br />
            <p>士模微电子总部位于北京海淀区，在成都设有全资子公司。士模微电子将依托技术领先优势，不断加大技术投入，深耕国内市场，以高可靠高性能的产品和优质的服务，致力于成为国内高性能模拟信号链芯片行业先行者。</p>
            <br />
            <!-- <h3 class="tab_title">公司资质</h3> -->
            <img style="margin:20px 0" src="../../assets/img29.jpg" alt="" />
            <!-- <h3 class="tab_title">投资伙伴</h3> -->
        </div>
        <!-- <div class="swiper_wrap anTransform" style="width:1300px;margin:0 auto;overflow: hidden;">
                <swiper id="media" class="homeSwiper" :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item, index) in swiperList" :key="index">
                    <img :src="item.coverImage" alt="" />
                </swiper-slide>
            </swiper>
            <div class="fleft bg"></div>
            <div class="fright bg"></div>
        </div> -->
    </div>
</template>
<script>
import {backPage} from '@/utils/common'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
export default {
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 4.5,
                slidesPerColumn: 2,
                spaceBetween: 10,
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                // },
                // autoplay: {
                //     delay: 1000,
                //     stopOnLastSlide: false,
                //     disableOnInteraction: true,
                // },
                
            },
            swiperList: [
                { coverImage: require('../../assets/logo/logo1.png') },
                { coverImage: require('../../assets/logo/logo2.png') },
                { coverImage: require('../../assets/logo/logo3.png') },
                { coverImage: require('../../assets/logo/logo4.png') },
                { coverImage: require('../../assets/logo/logo5.png') },
                { coverImage: require('../../assets/logo/logo6.png') },
                { coverImage: require('../../assets/logo/logo7.png') },
                { coverImage: require('../../assets/logo/logo8.png') },
                { coverImage: require('../../assets/logo/logo9.png') },
                { coverImage: require('../../assets/logo/logo10.png') },
                { coverImage: require('../../assets/logo/logo11.png') },
                { coverImage: require('../../assets/logo/logo12.png') },
                { coverImage: require('../../assets/logo/logo13.png') },
                { coverImage: require('../../assets/logo/logo14.png') },
            ]
        }
    },
    mounted(){
        document.getElementsByClassName('homeSwiper')[0].removeAttribute('overflow')
        // this.$refs.mySwiper.removeClass('swiper-container')
    },
    methods:{
        backPage
    }
}
</script>
<style lang="scss" scoped>
.title {
    border-left: 10px solid #d60e4c;
    line-height: 32px;
    text-indent: 30px;
    font-weight: bold;
    font-size: 36px;
    margin: 30px 0;
}

p {
    line-height: 32px;
    font-size: 16px;
}

.swiper_wrap {
    position: relative;

    .bg {
        height: 100%;
        position: absolute;
        width: 150px;
        top: 0;
        z-index: 999;
    }

    .bg.fleft {
        background-image: linear-gradient(to right, #eeeeee, transparent);
        left: 0;
    }

    .bg.fright {
        background-image: linear-gradient(to left, #eeeeee, transparent);
        right: 0;
    }

}
#media{
    animation:rolling 10s infinite linear;
}
#media:hover{
    animation-play-state:paused;
}
@keyframes rolling{
    0%{
        transform: translateX(0);
    }
    100%{
        transform: translateX(-800px);
    }
}
.homeSwiper{
    overflow: initial !important;
}
</style>


// WEBPACK FOOTER //
// src/views/about/index.vue